import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

interface ChangeNetworkDialogProps {
  open: boolean;
  integrationCode: string;
  loading: boolean;
  onClose: () => void;
  onSubmit: (networkCode: string) => void;
}

// Диалог добавления
export const AddNetworkDialog: React.FC<ChangeNetworkDialogProps> = ({
  open,
  integrationCode,
  loading,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const [networkCode, setNetworkCode] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (!networkCode.trim()) {
      setError(
        t('IntegrationsPage.Validation.NETWORK_CODE_REQUIRED') as string
      );
      return;
    }
    onSubmit(networkCode.trim());
    setError('');
  };

  const handleClose = () => {
    if (loading) return;
    onClose();
    setNetworkCode('');
    setError('');
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>
        {t('IntegrationsPage.ChangeNetworkDialog.ADD_TITLE', {
          code: integrationCode,
        })}
      </DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          label={t('IntegrationsPage.ChangeNetworkDialog.NETWORK_CODE_LABEL')}
          fullWidth
          value={networkCode}
          onChange={(e) => setNetworkCode(e.target.value)}
          disabled={loading}
          size="small"
          error={!!error}
          helperText={error}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          {t('IntegrationsPage.Common.CANCEL')}
        </Button>
        <Button onClick={handleSubmit} disabled={loading} variant="contained">
          {t('IntegrationsPage.ChangeNetworkDialog.SUBMIT_ADD')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddNetworkDialog;
